import { useTheme } from "@emotion/react";
import {
  AlarmOutlined,
  ApartmentOutlined,
  CalendarTodayOutlined,
  ContentCopy,
  PersonOutlineOutlined,
  SensorDoorOutlined,
  StarBorderOutlined,
  SubtitlesOutlined,
  SupportAgentOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useStyles from "./styles";

import apiCliente from "../../../services/apiCliente";
import { ChipPrioridade } from "../../../utils/chipsErp/chipPrioridade";
import { ChipSla } from "../../../utils/chipsErp/chipSla";
import { StatusIconCard } from "../../../utils/chipsErp/chipStatusCard";
import ModalAvaliacaoComponent from "../modalAvaliacaoComponent";
import TicketModalContentIxc from "../detailsTicketIxcComponent";

export default function OsComponentCliente(params) {
  const {
    protocolo = "",
    filial = "",
    descricao = "",
    cliente = "",
    dataCadastro = "",
    usuarioAbertura = "",
    status = 1,
    ticketId = "",
    id_ticket = "",
    getTicketDetails = () => {},
    isEdit = false,
    setSnackbar = () => {},
    selectedCliente = "",
    servicoId = "",
    labelErp = "",
    variantPaper = "elevation",
    allEtapasFluxoAtendimentos = [],
    setor = "",
    prioridade = "",
    assunto = "",
    sla = "",
    isAtendimento = false,
    typeTitleModal = "Atendimento",
    getForm = () => {},
    formId = null,
    isAvaliado = false,
    createAnswerForm = () => {},
  } = params;

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ticketDetails, setTicketDetails] = useState({});
  const [value, setValue] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [openAvaliacao, setOpenAvaliacao] = useState(false);
  const [viewed, setViewed] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const viewedItens = async () => {
    try {
      await apiCliente.post("/cliente/ticket/itens/viewed", {
        itensId: ticketDetails?.atendimento_mensagem?.map((item) =>
          item?.id_atendimento_mensagem?.toString(),
        ),
      });

      setViewed(true);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao visualizar mensagens",
        severity: "error",
      });
    } finally {
    }
  };
  const handleChange = (event, newValue) => {
    //adicionar viewed
    if (newValue === 1 && !viewed && ticketDetails) {
      viewedItens();
    }
    setValue(newValue);
  };
  const statusChamado = {
    "Aguardando Análise": 1,
    Resolvido: 2,
    Pendente: 3,
    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
    Reagendar: 13,
    NA: 14,
    Solucionado: 15,
    Novo: 16,
    "Em progresso": 17,
    Fechamento: 18,
    Encerramento: 19,
    Abertura: 20,
    Andamento: 21,
  };

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  function htmlForText(html) {
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    function extrairTexto(node) {
      let texto = "";

      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          texto += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const tag = child.tagName;

          switch (tag) {
            case "BR":
              texto += "\n";
              break;
            case "P":
            case "DIV":
              texto += extrairTexto(child) + "\n";
              break;
            case "LI":
              texto += "- " + extrairTexto(child) + "\n";
              break;
            case "UL":
            case "OL":
              texto += extrairTexto(child) + "\n";
              break;
            default:
              texto += extrairTexto(child);
          }
        }
      });

      return texto;
    }

    // Extrai texto e normaliza múltiplas quebras de linha
    const resultado = extrairTexto(tempDiv);
    return resultado.replace(/\n{3,}/g, "\n\n").trim();
  }

  const handleOpen = async () => {
    setOpen(true);
    setLoading(true);
    const response = await getTicketDetails(ticketId);

    setTicketDetails(response || {});
    setItensPublic((prev) => {
      const mensagens = [];
      const anexos = [];
      const anexosCliente = [];
      const rfo = [];
      for (const item of response?.itensTicketPublic || []) {
        if (item?.itemType === "mensagem") {
          mensagens.push(item?.itemId);
        } else if (item?.itemType === "anexo") {
          anexos?.push(item?.itemId);
        } else if (item?.itemType === "anexoCliente") {
          anexosCliente?.push(item?.itemId);
        } else if (item?.itemType === "rfo") {
          rfo?.push(item?.itemId);
        }
      }

      return {
        ...prev,
        mensagens,
        anexos,
        anexosCliente,
        rfo,
      };
    });

    setLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
    setValue(0);
    setViewed(false);
  };

  const handleOpenAvaliacao = async () => {
    setOpenAvaliacao(true);
    const response = await getForm(formId);
    setQuestions(response?.questions);
  };
  const handleCloseAvaliacao = () => {
    setOpenAvaliacao(false);
  };

  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      variant={variantPaper}
      sx={styles.paperContainer}
    >
      <Box sx={styles.boxHeaderStatus}>
        {StatusIconCard([statusChamado[status]], 2)}

        {ChipPrioridade(prioridade)}
      </Box>

      <Box sx={styles.containerHeader}>
        <Box sx={styles.boxProtocolo}>
          <Typography sx={styles.textInfoCard}> Protocolo:</Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {protocolo}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(protocolo);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = protocolo;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={styles.boxProtocolo}>
          <Typography sx={styles.textInfoCard}> {labelErp} ID:</Typography>
          <Typography
            sx={{
              ...styles.titleProtocolo,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {servicoId}
          </Typography>

          <Tooltip title="Clique para copiar">
            <IconButton
              size="small"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(servicoId);
                } catch (err) {
                  // Fallback para navegadores mais antigos ou sem permissão
                  const textArea = document.createElement("textarea");
                  textArea.value = servicoId;
                  document.body.appendChild(textArea);
                  textArea.select();
                  try {
                    document.execCommand("copy");
                  } catch (err) {
                    console.error("Falha ao copiar texto: ", err);
                  }
                  document.body.removeChild(textArea);
                }
                setSnackbar({
                  children: "Campo copiado!",
                  severity: "info",
                });
              }}
            >
              <ContentCopy sx={{ fontSize: "15px" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={styles.containerDescription}>
        <Typography sx={styles.description}>
          {(erp === "HUBSOFT" && descricao) ||
            (erp === "VOALLE" && htmlForText(descricao)) ||
            (erp === "IXC" && descricao)}
        </Typography>
      </Box>
      <Box sx={styles.boxInfos}>
        <Box
          sx={{
            ...styles.containerInfo,
          }}
        >
          <PersonOutlineOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Typography sx={styles.cardDescricao}>{cliente}</Typography>
        </Box>

        <Box sx={styles.containerInfoRow}>
          <Box sx={styles.containerDataAberturaRow}>
            <CalendarTodayOutlined
              sx={{
                ...styles.icon,

                fontSize: "18px",
              }}
            />{" "}
            <Tooltip title={"Data de abertura"}>
              <Typography sx={styles.cardDescricao}>{dataCadastro}</Typography>
            </Tooltip>
          </Box>
          <Box sx={styles.containerDataAberturaRow}>
            <Tooltip
              title={"SLA"}
              style={{ display: "flex", alignItems: "center", gap: 5 }}
            >
              <AlarmOutlined
                sx={{
                  ...styles.icon,

                  fontSize: "18px",
                }}
              />
              {ChipSla(sla)}
            </Tooltip>
          </Box>
        </Box>
        <Box sx={styles.containerInfoRow}>
          <Box
            sx={{
              ...styles.containerDataAberturaRow,
              width: id_ticket ? "50%" : "100%",
            }}
          >
            <SensorDoorOutlined
              sx={{
                ...styles.icon,
              }}
            />{" "}
            <Tooltip title={"Setor"}>
              <Typography
                sx={{
                  ...styles.cardDescricao,
                }}
              >
                {setor}
              </Typography>
            </Tooltip>
          </Box>
        </Box>

        <Box sx={styles.containerInfo}>
          <SubtitlesOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Tooltip title={"Assunto"}>
            <Typography
              sx={{
                ...styles.cardDescricao,
              }}
            >
              {assunto}
            </Typography>
          </Tooltip>
        </Box>
        <Box sx={styles.containerInfo}>
          <ApartmentOutlined
            sx={{
              ...styles.icon,
            }}
          />{" "}
          <Tooltip title={"Filial"}>
            <Typography
              sx={{
                ...styles.cardDescricao,
              }}
            >
              {filial}
            </Typography>
          </Tooltip>
        </Box>

        <Box sx={styles.containerInfo}>
          <SupportAgentOutlined
            sx={{
              ...styles.icon,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          />{" "}
          <Typography
            sx={{
              ...styles.cardDescricao,
              fontWeight: "bold",
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.main
                  : theme.palette.tertiary.main,
            }}
          >
            {usuarioAbertura}
          </Typography>
        </Box>
        <Box sx={styles.containerButton}>
          {formId && !isAvaliado && (
            <Button
              onClick={handleOpenAvaliacao}
              sx={{
                ...styles.buttonDetails,
                color: theme.palette.colors.black.dark,
              }}
              startIcon={<StarBorderOutlined />}
              variant="contained"
              size="small"
            >
              Avaliar
            </Button>
          )}

          <Button
            onClick={handleOpen}
            sx={styles.buttonDetails}
            startIcon={<VisibilityOutlined />}
            variant="outlined"
            size="small"
          >
            Detalhes
          </Button>
        </Box>
      </Box>

      <TicketModalContentIxc
        open={open}
        loading={loading}
        handleClose={handleClose}
        erp={erp}
        ticketDetails={ticketDetails}
        status={statusChamado[status]}
        labelTabsErp={labelTabsErp}
        value={value}
        handleChange={handleChange}
        isEdit={isEdit}
        setTicketDetails={setTicketDetails}
        itensPublic={itensPublic}
        setItensPublic={setItensPublic}
        htmlForText={htmlForText}
        setSnackbar={setSnackbar}
        isAtendimento={isAtendimento}
        typeTitleModal={typeTitleModal}
        isCliente={true}
      />

      <ModalAvaliacaoComponent
        open={openAvaliacao}
        handleClose={handleCloseAvaliacao}
        questions={questions}
        createAnswerForm={createAnswerForm}
        formId={formId}
        ticketId={ticketId}
      />
    </Paper>
  );
}
